import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { getWebClient } from './helpers/Helpers.js';
import Activity from './pages/Activity';
import Agenda from './pages/Agenda';
import Faq from './pages/Faq';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardEditOnly from './pages/DashboardEditOnly';
import DashboardRateReadOnly from './pages/DashboardRateReadOnly';
import NotFound from './pages/NotFound';
import PartnerProfile from './pages/PartnerProfile';
import PartnerAgenda from './pages/PartnerAgenda';
import Print from './pages/Print';
import Profile from './pages/Profile';
import Ratings from './pages/Ratings';
import Search from './pages/Search';

export const MainSettingsContext = React.createContext(null);

function App() {

    const [locationAndDates, setLocationAndDates] = useState(null);
    const [displayMode, setDisplayMode] = useState();
    const [authenticationToken, setAuthenticationToken] = useState(localStorage.getItem("authenticationToken"));

    const client = getWebClient();

    function locationAndDatesGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/getlocationanddates`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function displayModeGetGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/getdisplaymode`).then((response) => {
                resolve(response.data);
            });
        });
    }

    useEffect(() => {

        Promise.all([locationAndDatesGetPromise(), displayModeGetGetPromise()])

            .then((results) => {

                let locationAndDatesGetPromiseResult = results[0];
                let displayModePromiseResult = results[1];

                setLocationAndDates(locationAndDatesGetPromiseResult.locationAndDates);
                setDisplayMode(displayModePromiseResult.displayMode);

            })

    }, []);

    if (displayMode) {

        if (!authenticationToken || displayMode === 'LOCKED') {

            return (
                <>
                    <div className="wrapper">
                        <MainSettingsContext.Provider value={{ locationAndDates: locationAndDates }}>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/" element={<Login setAuthenticationToken={setAuthenticationToken} />}>
                                    </Route>
                                    <Route path="/faq" element={<Faq />}>
                                    </Route>
                                    <Route path="*" element={<NotFound />}>
                                    </Route>
                                </Routes>
                            </BrowserRouter>
                        </MainSettingsContext.Provider>
                    </div>
                </>
            );

        } else if (displayMode === 'EDITONLY') {

            return (
                <>
                    <div className="wrapper">
                        <MainSettingsContext.Provider value={{ locationAndDates: locationAndDates }}>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/" element={<DashboardEditOnly setAuthenticationToken={setAuthenticationToken} />}>
                                    </Route>
                                    <Route path="/profile" element={<Profile />}>
                                    </Route>
                                    <Route path="/faq" element={<Faq />}>
                                    </Route>
                                    <Route path="*" element={<NotFound />}>
                                    </Route>
                                </Routes>
                            </BrowserRouter>
                        </MainSettingsContext.Provider>
                    </div>
                </>
            );

        } else if (displayMode === 'RATEANDREADONLY') {

            return (
                <>
                    <div className="wrapper">
                        <MainSettingsContext.Provider value={{ locationAndDates: locationAndDates }}>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/" element={<DashboardRateReadOnly setAuthenticationToken={setAuthenticationToken} />}>
                                    </Route>
                                    <Route path="/print" element={<Print />}>
                                    </Route>
                                    <Route path="/faq" element={<Faq />}>
                                    </Route>
                                    <Route path="/ratings" element={<Ratings />}>
                                    </Route>
                                    <Route path="*" element={<NotFound />}>
                                    </Route>
                                </Routes>
                            </BrowserRouter>
                        </MainSettingsContext.Provider>
                    </div>
                </>
            );

        } else if (displayMode === 'FULL') {

            return (
                <>
                    <div className="wrapper">
                        <MainSettingsContext.Provider value={{ locationAndDates: locationAndDates }}>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/" element={<Dashboard setAuthenticationToken={setAuthenticationToken} />}>
                                    </Route>
                                    <Route path="/activity" element={<Activity />}>
                                    </Route>
                                    <Route path="/agenda" element={<Agenda />}>
                                    </Route>
                                    <Route path="/partnerprofile/:partnerid" element={<PartnerProfile />}>
                                    </Route>
                                    <Route path="/partneragenda/:partnerid" element={<PartnerAgenda />}>
                                    </Route>
                                    <Route path="/print" element={<Print />}>
                                    </Route>
                                    <Route path="/profile" element={<Profile />}>
                                    </Route>
                                    <Route path="/ratings" element={<Ratings />}>
                                    </Route>
                                    <Route path="/search" element={<Search />}>
                                    </Route>
                                    <Route path="/faq" element={<Faq />}>
                                    </Route>
                                    <Route path="*" element={<NotFound />}>
                                    </Route>
                                </Routes>
                            </BrowserRouter>
                        </MainSettingsContext.Provider>
                    </div>
                </>
            );

        }

    }

}

export default App;
